import React, { Fragment } from 'react';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import InlineFilterContainer from './InlineFilterContainer';

import './ListContainerControls.scss';

const ListContainerControls = (props) => {
  const { toggleFilters, children, inlineFilters } = props;

  if (inlineFilters) {
    return <InlineFilterContainer {...props}>{children}</InlineFilterContainer>;
  }

  return (
    <Fragment>
      <PopOver
        {...props}
        defaultOpen={toggleFilters}
        data-test-filter-button-popover
      >
        {children}
      </PopOver>
    </Fragment>
  );
};

export default ListContainerControls;
